import React, { useState, useEffect } from "react";
import { Layout, Drawer, Button } from "antd";
import { MenuOutlined } from "@ant-design/icons";
import { Outlet } from "react-router-dom";
import UserSidebar from "../components/UserSidebar";

const { Header, Sider, Content } = Layout;

const UserPanel = ({ children }) => {
  const [collapsed] = useState(false);
  const [activePage, setActivePage] = useState("/user/dashboard");
  const [isMobile, setIsMobile] = useState(false);
  const [drawerVisible, setDrawerVisible] = useState(false);

  const colorBgContainer = "#EDF1F1";

  // Detect screen size
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleDrawer = () => setDrawerVisible(!drawerVisible);

  return (
    <Layout style={{minHeight: '100vh', overflow: 'hidden'}}>
      {/* Sidebar for Desktop */}
      {!isMobile && (
        <Sider
          trigger={null}
          collapsible
          collapsed={collapsed}
          style={{
            background: '#EDF1F1',
            position: 'fixed',
            left: 0,
            zIndex: 111,
          }}
        >
          <UserSidebar setActivePage={setActivePage} activePage={activePage} />
        </Sider>
      )}

      {/* Drawer for Mobile */}
      {isMobile && (
        <Drawer
          title="Menu"
          placement="left"
          onClose={() => setDrawerVisible(false)}
          open={drawerVisible}
          bodyStyle={{padding: 0}}
          zIndex={111}
          className="ant-drawer-content"
          style={{
            width: '250px',
            boxShadow: 'none',
          }}
          contentWrapperStyle={{
            boxShadow: 'none',
          }}
        >
          <UserSidebar
            setActivePage={setActivePage}
            activePage={activePage}
            onMenuSelect={() => setDrawerVisible(false)}
          />
        </Drawer>
      )}

      <Layout
        style={{
          marginLeft: isMobile ? 0 : collapsed ? 80 : 250,
          background: '#EDF1F1',
        }}
      >
        {isMobile && (
          <Header
            style={{
              padding: '8px 16px',
              background: 'white',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <Button
              icon={<MenuOutlined />}
              onClick={toggleDrawer}
              className="bg-[#fff] border-none text-[16px]"
            />
            <p className="ml-2 text-[16px]">
              Welcome{' '}
              <span className="font-semibold">
                {localStorage.getItem('name')}
              </span>
            </p>
          </Header>
        )}
        <Content
          style={{
            padding: 0,
            minHeight: '100vh',
            background: colorBgContainer,
            overflowY: 'auto',
            zIndex: 1,
          }}
        >
          {children || <Outlet />}
        </Content>
      </Layout>
    </Layout>
  );
};

export default UserPanel;
